module.exports = __webpack_public_path__ + "headerBg-bb1fc0a71ef83a633d8e30fb16cfdb26.png";